import {Elements} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { PaymentEdit, Layout } from '../components'

const stripePromise = loadStripe('pk_test_51HjV1UETSg2g6rumokJ3bypsRTC9jK8HDnmIXB5Vb4iFyC2PcCnGPUp5hHFI1lUgaHdW6im4ICflTZDecRWFjQ9500PxdQ2Q8n');

const CheckoutWrapper = () => {
    return (
        <Layout>
            <Elements stripe={stripePromise} >
                <PaymentEdit />
            </Elements>
        </Layout>
    )
}

export default CheckoutWrapper